import { TExpectedSavingsByCategoryWidget } from './types'
import Typography from '../../../components/Typography/Typography'
import { TYPOGRAPHY_WEIGHT } from '../../../components/Typography'
import { currencyFormatter } from '../../ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'
import { useDashboardPopup } from '../Providers/DashboardPopupProvider'
import { Popup } from '../../../components/Popup'
import './styles.scss'

type Props = {
  data: TExpectedSavingsByCategoryWidget
}

export const ExpectedSavingsByCategoryPopup = ({ data }: Props) => {
  const {
    expectedSavingsByCategoryPopup: { state, actions }
  } = useDashboardPopup()
  return (
    <Popup
      visible={state.visible}
      onCancel={actions.close}
      title={state.title}
      className="expected-savings-popup"
      width={442}
      footer={null}
    >
      <div className="column gap-8 expected-savings-popup__content">
        {data.map(([key, value]) => {
          return (
            <div className="row space-between align-center full-width additional-values-row">
              <Typography.Body2 className="additional-values-row__title">
                {key}
              </Typography.Body2>
              <Typography.Body2 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
                ${currencyFormatter(value)}
              </Typography.Body2>
            </div>
          )
        })}
      </div>
    </Popup>
  )
}
